package com.tovtalk.utils.notifications

import com.tovtalk.data.remote.firebase.registerFcmTokenWithServerWeb
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.launch
import kotlin.coroutines.resume
import kotlin.coroutines.suspendCoroutine

private suspend fun requestPermissionSuspend(): Boolean = suspendCoroutine { cont ->
    val promise = js(
        "typeof Notification !== 'undefined' && Notification.requestPermission ? Notification.requestPermission() : Promise.resolve('denied')"
    )
    @Suppress("UNCHECKED_CAST")
    val p = promise as kotlin.js.Promise<*>
    p.then(
        { result: Any? -> cont.resume((result as? String) == "granted") },
        { _: Any? -> cont.resume(false) }
    )
}

actual fun requestNotificationPermissionIfNeeded(onResult: (granted: Boolean) -> Unit) {
    MainScope().launch(Dispatchers.Main) {
        val granted = try {
            requestPermissionSuspend()
        } catch (e: Throwable) {
            kotlin.js.console.error("[FCM Web] requestPermission failed:", e.message)
            false
        }
        onResult(granted)
    }
}

actual fun onLoginSuccessRegisterFcm() {
    MainScope().launch(Dispatchers.Main) {
        try {
            registerFcmTokenWithServerWeb()
        } catch (_: Throwable) { }
    }
}
